import { Observable } from "rxjs";

import { OrdersRepository } from "lib/repositories/index";
import st from "lib/utils/index";

export const OPEN = "orders/EditOrderCustomerDetailsModal/OPEN";
export const CLOSE = "orders/EditOrderCustomerDetailsModal/CLOSE";
export const UPDATE_ORDER = "orders/EditOrderCustomerDetailsModal/UPDATE_ORDER";
export const VALIDATE = "orders/EditOrderCustomerDetailsModal/VALIDATE";
export const SUBMIT = "orders/EditOrderCustomerDetailsModal/SUBMIT";
export const FETCH_SUBMIT_START = "orders/EditOrderCustomerDetailsModal/FETCH_SUBMIT_START";
export const FETCH_SUBMIT_SUCCESS = "orders/EditOrderCustomerDetailsModal/FETCH_SUBMIT_SUCCESS";
export const FETCH_SUBMIT_FAILURE = "orders/EditOrderCustomerDetailsModal/FETCH_SUBMIT_FAILURE";

export const stateSelector = (state) => state.orders.EditOrderCustomerDetailsModal;

const initialState = {
  opened: false,
  initialOrder: null,
  order: null,
  errors: new st.form.ValidationErrors(),
  valid: true,
  submitLoading: false,
  saved: false,
};

const reducers = {
  [OPEN]: (state, { order }) => {
    return {
      ...initialState,
      opened: true,
      initialOrder: order,
      order,
    };
  },

  [CLOSE]: (state) => {
    return {
      ...state,
      opened: false,
    };
  },

  [UPDATE_ORDER]: (state, { order }) => {
    return {
      ...state,
      order,
    };
  },

  [VALIDATE]: (state) => {
    const { order } = state;
    const errors = new st.form.ValidationErrors();

    errors.add(
      "base",
      st.validators.presence(order.customer_display_name) &&
        I18n.t("activerecord.errors.models.order.customer_display_name_missing")
    );

    order.customer_ordered_fields.forEach((orderedField) => {
      if (orderedField.product_order_field.preset_id === "customer_full_name") {
        errors.add(
          `order.ordered_product_order_fields[${orderedField.uuid}].value`,
          st.validators.length(orderedField.value, { minimum: 5, maximum: 100 })
        );
      }

      // orderedField.product_order_field.order_value_required && errors.add(`order.ordered_product_order_fields[${orderedField.uuid}].value`, st.validators.presence(orderedField.value))
    });

    order.order_customer_participants.forEach((participant) => {
      participant.customer_ordered_fields.forEach((orderedField) => {
        // orderedField.product_order_field.order_value_required && errors.add(`order.order_customer_participants[${participant.uuid}].ordered_product_order_fields[${orderedField.uuid}].value`, st.validators.presence(orderedField.value))
      });
    });

    if (errors.length > 0) {
      errors.add("base", I18n.t("papp.common.form_validation_error_message"));
    }

    return {
      ...state,
      errors,
      valid: errors.valid,
    };
  },

  [FETCH_SUBMIT_START]: (state) => {
    return {
      ...state,
      submitLoading: true,
      errors: new st.form.ValidationErrors(),
    };
  },

  [FETCH_SUBMIT_SUCCESS]: (state, { order }) => {
    return {
      ...state,
      initialOrder: order,
      saved: true,
      submitLoading: false,
    };
  },

  [FETCH_SUBMIT_FAILURE]: (state, { errors }) => {
    return {
      ...state,
      submitLoading: false,
      errors,
    };
  },
};

const epics = [
  (actions$, { getState, dispatch }) =>
    actions$
      .ofType(SUBMIT)
      .switchMap(() => {
        setTimeout(() => {
          dispatch(validate());
        });
        return actions$.ofType(VALIDATE).take(1);
      })
      .filter(() => {
        const { valid } = stateSelector(getState());
        return valid;
      })
      .flatMap(() => {
        const { initialOrder, order } = stateSelector(getState());
        const mapOrderToOrderData = (order) => ({
          id: order.id,
          token: order.token,
          customer_locale: order.customer_locale,
          ordered_product_order_fields: order.customer_ordered_fields,
          order_customer_participants: order.order_customer_participants.map((participant) => ({
            id: participant.id,
            ordered_product_order_fields: participant.customer_ordered_fields,
          })),
        });
        return Observable.concat(
          Observable.of({ type: FETCH_SUBMIT_START }),
          OrdersRepository.updateCustomerDetails(mapOrderToOrderData(order), mapOrderToOrderData(initialOrder))
            .map((order) => {
              return { type: FETCH_SUBMIT_SUCCESS, order };
            })
            .catch((error) => {
              st.api.handleError(error, { getState, dispatch });
              const errors = new st.form.ValidationErrors([["base", st.api.findResponseErrorMessage(error)]]);
              return Observable.of({
                type: FETCH_SUBMIT_FAILURE,
                errors,
                error,
              });
            })
        );
      }),
];

export function open(order) {
  return { type: OPEN, order };
}

export function close() {
  return { type: CLOSE };
}

export function updateOrder(order) {
  return { type: UPDATE_ORDER, order };
}

export function validate({ submitValidate = false } = {}) {
  return { type: VALIDATE, submitValidate };
}

export function submit() {
  return { type: SUBMIT };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/orders/EditOrderCustomerDetailsModal/index.js